import { Href } from "../../utils/Constant"

export const shiftsOverviewData = [
    {
        color:"primary",
        title:"New",
        count:86
    },
    {
        color:"secondary",
        title:"Waiting for approval",
        count:210
    },
    {
        color:"warning",
        title:"Assigned",
        count:95
    },
    {
        color:"tertiary",
        title:"Cancelled",
        count:37
    }
]

export const notificationsData = [
    {
        img:"wallet.png",
        link:Href,
        title:"New daily offer added",
        subTitle:"New user-only offer added",
        color:"primary",
        date:"10 Sep,2024"
    },
    {
        img:"shield-dne.png",
        link:Href,
        title:"Product Evaluation",
        subTitle:"Changed to a new workflow",
        color:"info",
        date:"12 Oct,2024"
    },
    {
        img:"graph.png",
        link:Href,
        title:"Return of a Product",
        subTitle:"452 items were returned",
        color:"warning",
        date:"15 Mar,2024"
    },
    {
        img:"ticket-star.png",
        link:Href,
        title:"Recently Paid",
        subTitle:"Mastercard payment of $343",
        color:"tertiary",
        date:"20 Jun,2024"
    }
]

export const upcomingData = [
    {
        img:"05.png",
        link:Href,
        name:"John Elliot",
        date:"21 Oct 2024",
        time:"15:55 AM"
    },
    {
        img:"06.png",
        link:Href,
        name:"Ashley Hart",
        date:"12 Oct 2024",
        time:"10:20 AM"
    },
    {
        img:"07.png",
        link:Href,
        name:"Anna lverson",
        date:"05 Oct 2024",
        time:"14:30 AM"
    },
    {
        img:"08.png",
        link:Href,
        name:"Dana Lemon",
        date:"01 Oct 2024",
        time:"18:45 AM"
    }
]

export const activeTableData = [
    {
        img:"01.jpg",
        name:"Joshua Wood",
        position:"Joshua Wood",
        status:"02 hours",
        color:"primary",
        btnName:"Away",
        link:Href
    },
    {
        img:"02.jpg",
        name:"Ashley Hart",
        position:"Website Design",
        status:"05 hours",
        color:"secondary",
        btnName:"Working",
        link:Href
    },
    {
        img:"03.jpg",
        name:"Anna lverson",
        position:"UX Research",
        status:"10 hours",
        color:"secondary",
        btnName:"Working",
        link:Href
    },
    {
        img:"04.jpg",
        name:"Ron Dayley",
        position:"234+ Online",
        status:"15 hours",
        color:"primary",
        btnName:"Away",
        link:Href
    }
]

export const salesByProductTableData = [
    {
        img:"1.png",
        link:Href,
        fileName:"Touch sensor Lamp",
        amount:"7.938",
        sold:"52.93%",
        color:"primary",
        value:70
    },
    {
        img:"2.png",
        link:Href,
        fileName:"Bluetooth headphone",
        amount:"2.937",
        sold:"12.52%",
        color:"secondary",
        value:40
    },
    {
        img:"3.png",
        link:Href,
        fileName:"Apple watch series 8",
        amount:"1.923",
        sold:"84.12%",
        color:"warning",
        value:60
    },
    {
        img:"4.png",
        link:Href,
        fileName:"Macbook Pro M1",
        amount:"5.538",
        sold:"01.41%",
        color:"tertiary",
        value:80
    },
    {
        img:"5.png",
        link:Href,
        fileName:"iphone 12 Pro max",
        amount:"8.258",
        sold:"14.34%",
        color:"primary",
        value:50
    }
]

export const salesData = [
    {
        img:"customers.png",
        title:"Customers",
        count:"1.736",
        result:"+3.7%",
        color:"success"
    },
    {
        img:"revenue.png",
        title:"Revenue",
        count:"$9.247",
        result:"-0.10%",
        color:"danger"
    },
    {
        img:"profit.png",
        title:"Profit",
        count:"80%",
        result:"+11.6%",
        color:"success"
    }
]

export const projectsTableBodyData = [
    {
        img:"1.png",
        title:"Rules Post on Dribble",
        color:"primary",
        type:"Document",
        date:"12 Aug 2024",
        size:"200 Kb",
        author:"Monry Hasu"
    },
    {
        img:"2.png",
        title:"Login & Sign Up Ui",
        color:"secondary",
        type:"Animation",
        date:"19 Mar 2024",
        size:"3.5 Mb",
        author:"Alex Madus"
    },
    {
        img:"3.png",
        title:"Nft website Pages",
        color:"warning",
        type:"Image",
        date:"30 Jun 2024",
        size:"800 Kb",
        author:"Nomru Nalij"
    },
    {
        img:"4.png",
        title:"Square Dashboard",
        color:"tertiary",
        type:"Document",
        date:"24 Oct 2024",
        size:"2.8 Mb",
        author:"Willium sen"
    },
    {
        img:"1.png",
        title:"Rules Post on Dribble",
        color:"primary",
        type:"Document",
        date:"12 Aug 2024",
        size:"200 Kb",
        author:"Monry Hasu"
    },
]